module.exports = __webpack_public_path__ + "img/Stage_2_Diff.943ee32d.jpg";